import { useEffect } from 'react'
import styles from './styles.module.scss'
import Image from 'next/image'

export const RubicWidget = () => {
  useEffect(() => {
    const jup = window['Jupiter']
    if (jup) {
      jup.init({
        displayMode: 'integrated',
        integratedTargetId: 'integrated-terminal',
        endpoint:
          'https://solana-mainnet.g.alchemy.com/v2/238v0qVrYW58RgpW1_iHVCRVIVsfmHTX',
        platformFeeAndAccounts: {
          referralAccount: 'CCv7CMt83LWtNo4Fti7nvMVotnmt5CVCbwhXWSvHZ9oJ',
          feeBps: 100,
        },
        // onSuccess: onSwapSuccess,
        // onSwapError: onSwapError,
        containerStyles: {
          height: '600px',
          background: 'black',
          padding: '10px',
          zIndex: '0',
          borderRadius: '10px',
          width: '100%', // Default to 100% width
        },
      })
    }

    // Customization logic after Jupiter Swap is initialized
    const swapContainer = document.getElementById('integrated-terminal')
    const intervalId = setInterval(() => {
      const jupiterLogoContainer = swapContainer.querySelector(
        '.flex.items-center.space-x-2'
      )
      if (jupiterLogoContainer) {
        // Replace the Jupiter logo
        const jupiterLogo = jupiterLogoContainer.querySelector('img')
        if (jupiterLogo) {
          jupiterLogo.src = '/assets/logo.svg' // Replace with your logo path
          jupiterLogo.alt = 'Coin360 Swap'
          jupiterLogo.style.width = '100px' // Adjust width as needed
          jupiterLogo.style.height = '30px' // Adjust height as needed
        }

        // Hide the text next to the logo
        const jupiterText = jupiterLogoContainer.querySelector('span')
        if (jupiterText) {
          jupiterText.style.display = 'none'
        }

        // Add margin to the form
        const formElement = swapContainer.querySelector('form')
        if (formElement) {
          formElement.style.marginTop = '30px' // Adjust the margin as needed
        }

        // Add the v3 label next to the logo
        // const v3Label = document.createElement('div')
        // v3Label.innerText = 'V3'
        // v3Label.style.background = '#7CC07C'
        // v3Label.style.color = 'white'
        // v3Label.style.padding = '2px'
        // v3Label.style.marginLeft = '2px'
        // v3Label.style.borderRadius = '3px'
        // v3Label.style.fontSize = '10px'
        // v3Label.style.position = 'relative'
        // v3Label.style.transform = 'translateY(-50%)' // Move the label up
        // jupiterLogoContainer.appendChild(v3Label)

        clearInterval(intervalId)
      }
    }, 100)
  }, [])

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.subHeader}>
          <h2>COIN360 Swap - Powered by</h2>
          <span className={styles.img}>
            <Image
              src='/assets/jupiter-logo.svg'
              height={25}
              width={25}
              className={styles.img}
              alt='Jupiter'
            />
          </span>
          <h2>Jupiter</h2>
        </div>
      </div>
      <div id='integrated-terminal' className={styles.swapContainer} />
    </div>
  )
}

export default RubicWidget
